import React, { useState } from 'react';
import AddExperienceModal from '../modals/AddExperienceModal';
import { summariseCareerExperience } from '../../../utils/careerExperience';

const ExperienceSection = ({ isEditing, experience = [], onUpdateExperience, hideResumeUpload = false }) => {
  const [showExperienceModal, setShowExperienceModal] = useState(false);

  const handleAddExperience = (experienceData) => {
    const newExperience = {
      id: Date.now(),
      ...experienceData
    };
    onUpdateExperience([...experience, newExperience]);
    setShowExperienceModal(false);
  };

  const handleRemoveExperience = (experienceId) => {
    const updatedExperience = experience.filter(exp => exp.id !== experienceId);
    onUpdateExperience(updatedExperience);
  };

  // Shared with the read-only staff timeline — see src/utils/careerExperience.js.
  // Stations without a usable start date are skipped, never estimated.
  const { years, months } = summariseCareerExperience(experience);

  return (
    <div className="bg-white p-6 border border-[#E6E6E6]">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-[11px] font-bold text-[#3C3C3C]">EXPERIENCE</h2>
        {isEditing && (
          <button
            onClick={() => setShowExperienceModal(true)}
            className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg"
          >
            + Add experience
          </button>
        )}
      </div>

      <div className="space-y-4">
        {experience.length === 0 && (
          <div className="p-4 text-sm text-gray-500 border border-dashed border-gray-300 rounded-md">
            No experience added yet.
          </div>
        )}
        
        {experience.map((exp, index) => (
          <div key={exp.id} className="border-b border-[#D6DBEA] p-4">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-[#2283FF] bg-opacity-10 rounded-xl flex items-center justify-center flex-shrink-0">
                <span className="text-[#2283FF] text-lg font-bold">
                  {exp.club ? exp.club.charAt(0).toUpperCase() : 'C'}
                </span>
              </div>
              <div className="flex-1">
                <div className="text-[#222A35] text-[20px] font-bold">{exp.role}</div>
                <div className="text-[#222A35] text-[16px] font-bold">{exp.club}</div>
                <div className="text-[#646B7E] text-[14px]">
                  {[exp.from, exp.to].filter(Boolean).join(" - ")}
                  {exp.country ? ` | ${exp.country}` : ""}
                  {exp.type ? ` | ${exp.type}` : ""}
                </div>
              </div>
              {isEditing && (
                <button
                  onClick={() => handleRemoveExperience(exp.id)}
                  className="w-8 h-8 bg-[#FF4D4F1A] border border-[#FF4D4F] rounded-full flex items-center justify-center"
                >
                  <span className="text-[#FF4D4F] text-sm font-bold">×</span>
                </button>
              )}
            </div>
          </div>
        ))}

        {experience.length > 0 && (
          <div className="px-4 py-2 w-fit rounded-lg border border-[#FF4D4F30]" 
               style={{
                 background: "linear-gradient(90deg, rgba(244, 227, 237, 0.1) 0%, rgba(246, 167, 85, 0.1) 100%)"
               }}>
            <span className="text-[#646B7E] text-[14px]">
              Total: {years} {years === 1 ? "year" : "years"}
              {months > 0 ? `, ${months} ${months === 1 ? "month" : "months"}` : ""}
            </span>
          </div>
        )}
      </div>

      {/* Experience Modal */}
      {showExperienceModal && (
        <AddExperienceModal
          onClose={() => setShowExperienceModal(false)}
          onAdd={handleAddExperience}
          hideResumeUpload={hideResumeUpload}
        />
      )}
    </div>
  );
};

export default ExperienceSection; 